import React, { useEffect, useState } from 'react'
import { Navbar, Row, Col, Container } from 'react-bootstrap'
import { useSelector, useDispatch, connect } from 'react-redux'
import BannerMainImageSection from 'components/bannerMainImageSection'
import CarImageSection from 'components/pages/proposal/carImageSection'
import CarDetailsSection from 'components/pages/proposal/carDetailsSection'
import CustomerSection from 'components/pages/proposal/customerSection'
import NovatedLeaseSection from 'components/pages/proposal/novatedLeaseSection'
import ProposalSummarySection from 'components/pages/proposal/proposalSummarySection'
import DeductionSection from 'components/pages/proposal/deductionSection'
import TakeHomeSection from 'components/pages/proposal/takeHomeSection'
import { getQueryStringValueByParameter } from 'helpers'
import { fetchIndividualEstimate } from 'actions/emailIndividualEstimateActions'
import { useHistory } from 'react-router-dom'
import { PrimaryButton } from '@mmsg/louie/dist/styledComponents/Button/PrimaryButton'
import { fireInteractionCustomEvent } from '../../../../helpers'
import Footer from 'components/footer'
import { Icon } from 'icons'
import withLocation from 'components/withLocation'
import Loader from 'components/loader'

// ToDo: This whole component should be removed post release of DEP Oly v1.0 with the latest API changes
const QuoteDetails = ({ applicationRoles, accessToken }) => {
  let dispatch = useDispatch()
  useEffect(() => {
    let url = window.location.href.toLowerCase()
    if (url.indexOf('&oppid=') !== -1 && url.indexOf('?quoteid=') !== -1) {
      let oppId = getQueryStringValueByParameter('oppid', url)
      let quoteId = getQueryStringValueByParameter('quoteid', url)
      if (applicationRoles && applicationRoles.isConsultant) {
        dispatch(fetchIndividualEstimate(oppId, quoteId, true, accessToken))
      } else {
        dispatch(fetchIndividualEstimate(oppId, quoteId, false))
      }
    }
  }, [])
  let history = useHistory()
  let estimateData = {
    proposalEstimate: null,
    userEmployer: null,
  }
  
  let proposalEstimate = useSelector(
    (state) => state.individualEstimate.estimate
  )
  let isProposal = useSelector((state) => state.individualEstimate.isProposal)
  let proposalNumber = useSelector(
    (state) => state.individualEstimate.proposalNumber
  )
  let dateOfProposalAcceptance = useSelector(
    (state) => state.individualEstimate.dateOfProposalAcceptance
  )
  let user = useSelector((state) => state.user)
  let payFrequency =
    user && user.employer && user.employer.payFrequency
      ? user.employer.payFrequency
      : ''

  let takeHomePayTitle = '5. Your resulting take home pay'

  estimateData.proposalEstimate = proposalEstimate
  estimateData.userEmployer = user && user.employer ? user.employer : null

  let negativeEquityAmount = 0
  let proposalExpiryDate = new Date()

  let isValidDate = (date) => {
    return new Date(date) !== 'Invalid Date' && !isNaN(new Date(date))
      ? true
      : false
  }

  if (proposalExpiryDate !== null && isValidDate(proposalExpiryDate)) {
    proposalExpiryDate.setDate(proposalExpiryDate.getDate() + 30)
  }

  var novatedLeaseData = {
    proposalEstimate: proposalEstimate,
    negativeEquityAmount: negativeEquityAmount,
  }

  const pdfViewClick = () => {
    history.push(history.location.pathname.replace(/\/$/, '') + '/pdfview')
    fireInteractionCustomEvent({
      detail: {
        eventType: 'custom link click',
        data: {
          category: 'button',
          section: 'mylease',
          text: 'view pdf',
          label: 'view pdf',
        },
      },
    })
  }
  let deductionSectionTitle = () => {
    let title = '4. '
    if (payFrequency) {
      title += 'Your total ' + payFrequency + ' deductions'
    } else {
      title += 'Your total pay cycle deductions'
    }

    return title
  }
  return (
    <>
      <div
        data-html2canvas-ignore="true"
        style={{
          background: '#CCCCCC',
          position: 'sticky',
          display: 'flex',
          justifyContent: 'flex-end',
          top: 0,
          zIndex: 3,
        }}
      >
        <PrimaryButton extendOnMob onClick={pdfViewClick} className="m-2">
          View PDF
        </PrimaryButton>
      </div>
      <div id="pdf">
        <div style={{ margin: '10px' }}>
            <Icon iconType="olyMainLogo" size={2} />
            TrickedJumbotron        </div>
        <div className="review-proposal-page">
          <BannerMainImageSection src="/images/proposal_banner.png">
            <div className="text-center">
              <div className="banner-content theme-dark text-left">
                <div>
                  {isProposal && (
                    <h1 className="mb-2">NOVATED LEASE PROPOSAL DETAILS</h1>
                  )}
                  {!isProposal && (
                    <h1 className="mb-2">NOVATED LEASE ESTIMATE DETAILS</h1>
                  )}
                </div>
              </div>
            </div>
          </BannerMainImageSection>
          {!proposalEstimate && (
            <Container>
              <div className="mt-5 mb-5 d-flex justify-content-center">
                <Loader />
              </div>
            </Container>
          )}
          {proposalEstimate && (
            <>
              <CarImageSection data={proposalEstimate} />
              {user && (
                <CustomerSection
                  data={user}
                  title="1. Your details"
                  isProposal={isProposal}
                  proposalNumber={proposalNumber}
                  dateOfProposalAcceptance={dateOfProposalAcceptance}
                ></CustomerSection>
              )}
              <CarDetailsSection
                data={proposalEstimate}
                title="2. The car details"
              />
              <NovatedLeaseSection
                data={novatedLeaseData}
                title="3. Your novated lease"
              />
              {estimateData.proposalEstimate && estimateData.userEmployer && (
                <DeductionSection
                  data={estimateData}
                  title={deductionSectionTitle()}
                />
              )}
              <TakeHomeSection
                data={proposalEstimate}
                title={takeHomePayTitle}
              />
            </>
          )}
          <div className="container-md navbar-container flex-row-reverse flex-md-row justify-content-center mt-5 mb-5 text-center">
            <Navbar.Brand></Navbar.Brand>
          </div>
          <div className="container-md">
            <Row className="mt-5">
              <Col xs={12}>
                <Footer fromEmail />
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </>
  )
}

function mapStateToProps(state, ownProps) {
  const applicationRoles = state.applicationRoles
  const accessToken = state.auth.accessToken

  return {
    applicationRoles,
    accessToken,
  }
}
export default connect(mapStateToProps)(withLocation(QuoteDetails))
